
import React, { useEffect, useState } from 'react';

export const Celebration: React.FC<{ active: boolean }> = ({ active }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (active) {
            setVisible(true);
            const t = setTimeout(() => setVisible(false), 6000);
            return () => clearTimeout(t);
        }
    }, [active]);

    if (!visible) return null;

    return (
        <div className="fixed inset-0 z-[100000] pointer-events-none flex items-center justify-center overflow-hidden">
            <div className="absolute inset-0 bg-smart-gold/10 backdrop-blur-sm animate-pulse"></div>
            
            {/* Particules simulées */}
            {Array.from({length: 40}).map((_, i) => (
                <div 
                    key={i}
                    className="absolute w-2 h-2 bg-smart-gold rounded-full animate-float-particle"
                    style={{
                        left: `${Math.random() * 100}%`,
                        top: `${Math.random() * 100}%`,
                        animationDelay: `${Math.random() * 2}s`,
                        animationDuration: `${3 + Math.random() * 4}s`,
                        opacity: 0.6
                    }}
                ></div>
            ))}

            <div className="relative text-center animate-virtuoso-reveal">
                <div className="text-[12px] font-black text-smart-gold uppercase tracking-[1em] mb-4">PERFORMANCE PARFAITE</div>
                <h2 className="text-8xl md:text-9xl font-black italic text-white uppercase tracking-tighter drop-shadow-[0_0_50px_rgba(218,144,0,0.8)]">
                    VIRTUOSO
                </h2>
                <div className="mt-8 flex justify-center gap-2">
                    {[1,2,3,4,5].map(s => <span key={s} className="text-4xl">⭐</span>)}
                </div>
            </div>

            <style>{`
                @keyframes float-particle {
                    0% { transform: translateY(0) rotate(0deg); opacity: 0; }
                    20% { opacity: 0.6; }
                    100% { transform: translateY(-100vh) rotate(360deg); opacity: 0; }
                }
                @keyframes virtuoso-reveal {
                    0% { transform: scale(0.8); opacity: 0; filter: blur(20px); }
                    10% { transform: scale(1.1); opacity: 1; filter: blur(0px); }
                    90% { transform: scale(1); opacity: 1; }
                    100% { transform: scale(1.2); opacity: 0; filter: blur(40px); }
                }
                .animate-virtuoso-reveal { animation: virtuoso-reveal 6s cubic-bezier(0.2, 1, 0.3, 1) forwards; }
            `}</style>
        </div>
    );
};
